import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent';
import NavbarCustomerComponent from '../../components/NavbarComponent/NavbarCustomerComponent';
import CustomerOrdersDashboardComponent from '../../components/CustomerOrdersDashboardComponent/CustomerOrdersDashboardComponent';
import TheoDoiDonHangComponent from '../../components/TheoDoiDonHangComponent/TheoDoiDonHangComponent'
import OrderFormComponent from '../../components/OrderFormComponent/OrderFormComponent';
import ChatBoxComponent from '../../components/ChatBoxComponent/ChatBoxComponent';

const CustomerHomePage = ({ setIsLoggedIn }) => {
  const [componentDuocChon, setComponentDuocChon] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768); // Sidebar mặc định đóng trên mobile

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      const newState = !prev;
      //console.log('Trạng thái sidebar sau toggle:', newState);
      return newState;
    });
  };
  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderContent = () => {
    switch (componentDuocChon) {
    case 'donHang':
        return <CustomerOrdersDashboardComponent />;
    case 'datDon':
        return <OrderFormComponent/>;
    case 'theoDoiDonHang':
        return <TheoDoiDonHangComponent/>;
    case 'chatBox':
        return <ChatBoxComponent/>;        
      default:
        return <CustomerOrdersDashboardComponent />;
    }
  };

  return (
    <div className="d-flex flex-column vh-100">
      {/* Header */}
      <div style={{ height: '80px', position: 'fixed', width: '100%', top: 0, zIndex: 1000 }}>
        <HeaderComponent setIsLoggedIn={setIsLoggedIn} toggleSidebar={toggleSidebar} />
      </div>

      {/* Main Content */}
      <div style={{ display: 'flex', flexGrow: 1, marginTop: '80px' , padding: '0'}}>
        {/* Sidebar cố định */}
        <div
          style={{
            width: isSidebarOpen ? '16.67%' : '0',
            height: 'calc(100vh - 80px)',
            overflow: 'hidden',
            backgroundColor: '#fff',
            borderRight: '1px solid #ccc',
            transition: 'width 0.3s ease',
            zIndex: 999,
            padding: 0,
            margin: 0,
            boxSizing: 'border-box',
          }}
        >
          {isSidebarOpen && (
            <NavbarCustomerComponent
              setComponentDuocChon={setComponentDuocChon}
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          )}
        </div>

        {/* Nội dung chính */}
        <div
          style={{
            flexGrow: 1,
            marginLeft: isSidebarOpen ? '4%' : '0',
            transition: 'margin-left 0.3s ease',
            padding: '20px',
            height: 'calc(100vh - 80px)',
            overflowY: 'auto',
            width: '100%',
          }}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default CustomerHomePage;
